import React from "react";
import { Handle } from "@xyflow/react";

export const IconGridNode = ({ id, data }) => {
  const connectionIndicatorStyle = {
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
  };

  return (
    <div
      className="flex flex-wrap justify-center items-center text-center h-auto rounded-lg p-2 relative"
      style={{ width: data.width }}
    >
      {data.items.map((item, index) => (
        <div
          key={index}
          className="w-1/8 p-4 flex flex-col justify-center items-center"
        >
          <img
            src={item.data.image}
            alt={`Icon ${index}`}
            className="w-9 h-9"
          />
          <div>{item.data.label}</div>
        </div>
      ))}
      {data.top && (
        <Handle
          type="target"
          position="top"
          style={{ ...connectionIndicatorStyle }}
          id={id}
        />
      )}
      {data.bottom && (
        <Handle
          type="source"
          position="bottom"
          style={{ ...connectionIndicatorStyle }}
          id={id}
        />
      )}
    </div>
  );
};
